import { useNavigate } from 'react-router-dom';

import InviteFriendsPage from '../inviteFriends/InviteFriendsPage';

import useFriendsCup from '@/hooks/useFriendsCup';
import useTourney from '@/hooks/useTourney';
import ROUTES from '@/router/routes';
import { createFriendsCupInviteServices } from '@/services/friendsCupAdapter';
import { SECTION_NAME_FOR_ADS } from '@/utils/ads';

function InviteFCup() {
  const { groupData, handleSetGroup } = useFriendsCup();
  const { tourneyData, handleSetTourney } = useTourney();
  const { idGrupo } = groupData;

  const navigate = useNavigate();

  const tournamentServices = createFriendsCupInviteServices();

  const handleNavigateToGroup = () => {
    navigate(ROUTES.friendsCup.viewTeam);
    handleSetTourney({
      ...tourneyData,
      id: idGrupo,
    });
    handleSetGroup({
      ...groupData,
      idGrupo,
    });
  };

  return (
    <InviteFriendsPage
      adsSections={SECTION_NAME_FOR_ADS.copadeamigos}
      competitionId={groupData.idGrupo}
      redirectRoute={handleNavigateToGroup}
      services={tournamentServices}
      type="cup"
    />
  );
}

export default InviteFCup;
